import { accessTypes } from "./accessTypes";

/**
 * Calendar sync is granted to every role that actually runs events, not just
 * Owner/Admin. It was previously bundled inside `eventManagement`, so the only
 * way to give an Event Director calendar access would have been to also hand
 * them sold-by, invoice, status and sign-date editing. It is granted on its own
 * below instead.
 *
 * Excluded: Staffer, Associate, Guest. The backend already matches this — the
 * endpoint the sync writes through (PATCH /v1/event/:id/status) denies only
 * STAFFER and GUEST — so nothing server-side needs to change.
 */
const canSyncCalendar = accessTypes.eventManagement.canSyncCalendar;

export const roles = {
  owner: [
    ...Object.values(accessTypes.eventManagement),
    ...Object.values(accessTypes.contractManagement),
    ...Object.values(accessTypes.statistics),
    ...Object.values(accessTypes.contractEditing),
  ],

  admin: [
    ...Object.values(accessTypes.eventManagement),
    ...Object.values(accessTypes.contractManagement),
    ...Object.values(accessTypes.statistics),
    ...Object.values(accessTypes.contractEditing),
  ],

  "event director lead auditor": [
    ...Object.values(accessTypes.statistics),
    ...Object.values(accessTypes.contractEditing),
    canSyncCalendar,
  ],

  "event director lead": [
    ...Object.values(accessTypes.statistics),
    ...Object.values(accessTypes.contractEditing),
    canSyncCalendar,
  ],

  "event director": [
    ...Object.values(accessTypes.statistics),
    ...Object.values(accessTypes.contractEditing),
    canSyncCalendar,
  ],

  "event director assistant": [
    ...Object.values(accessTypes.statistics),
    ...Object.values(accessTypes.contractEditing),
    canSyncCalendar,
  ],

  "staffing manager": [
    ...Object.values(accessTypes.statistics),
    canSyncCalendar,
  ],

  staffer: [...Object.values(accessTypes.statistics)],

  associate: [...Object.values(accessTypes.statistics)],

  guest: [],
};
